import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { AuthService } from "../../../../services/auth.service";
import { fadeIn } from "../../../animations/basic-animation";
import { DarkModeService } from "../../../../services/dark-mode.service";
import { filter, Observable } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../store";
import { UserProfileActions } from "../../../../store/entities/user-management/user-profile/user-profile.actions";
import { User } from "../../../../store/entities/user-management/users/users.model";
import { userProfileFeature } from "../../../../store/entities/user-management/user-profile/user-profile.reducer";
import { WarehouseAddComponent } from "../../../../modules/warehouse-management/warehouses-list/warehouse-add/warehouse-add.component";
import { SettingsService } from "../../../../services/settings.service";
import { ResetPasswordComponent } from "../../../../guest/reset-password/reset-password.component";
import { MatDialogRef } from "@angular/material/dialog";
import { SessionTimeoutWarnDialogComponent } from "../../session-timeout-warn-dialog/session-timeout-warn-dialog.component";
import { environment } from "../../../../../environments/environment";
import { UserViewComponent } from "../../../../modules/user-management/users-list/user-view/user-view.component";
import { NavigationEnd, Router } from "@angular/router";

@Component({
  selector: "app-top-nav-bar",
  templateUrl: "./top-nav-bar.component.html",
  styleUrl: "./top-nav-bar.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeIn],
})
export class TopNavBarComponent implements OnInit {
  authUsers$: Observable<any[]>; // Define a property to hold the user data
  userProfile$!: Observable<User>;
  private settingsService: SettingsService = inject(SettingsService);
  sidebarWidth = 250; // expanded sidebar width
  collapsedSidebarWidth = 60;
  isSidebarExpanded: any;
  currentRoute: string = "";
  currentPage: string = "";
  secondLastRoute: string = '';

  constructor(private store: Store<AppState>, private router: Router,private cdr: ChangeDetectorRef) {
    this.loadUserProfile();
  }

  authService = inject(AuthService);
  // darkModeService: DarkModeService = inject(DarkModeService);

  @Input() currentState: "openState" | "closeState" = "closeState";
  @Input() isDrawable: boolean = false;
  @Output() drawerToggle = new EventEmitter<any>();

  // languages: string[] = ['English', 'Portuguese', 'Spanish'];
  // activeLang: string = 'English'

  activeLightMode: "light"  = "light";
  userProfileData: any;
      @Input() fullWidth: boolean = false; // default = sidebar mode
    @Input()isLanding : boolean = false; // default = sidebar mode

  userProfile: { firstName: string; email: string } = {
    firstName: "",
    email: "",
  };

  profileMenu: { name: string; path: string; icon: string; slug: string }[] = [
    { name: "Profile", icon: "account_circle", path: "", slug: "profile" },
    { name: "Change Password", icon: "lock", path: "", slug: "changePassword" },
    {name: "Logout", icon: 'power_settings_new', path: '', slug: 'logout'},
  ];

  ngOnInit(): void {
    this.activeLightMode = "light";

    // Track current route
    this.currentRoute = this.router.url;
    this.updateCurrentPage(this.router.url);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.urlAfterRedirects;
        this.updateCurrentPage(event.urlAfterRedirects);
        this.cdr.markForCheck();
      });
  }
  goBack() {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      this.router.navigate(["/landing"]);
    }
  }

updateCurrentPage(url: string) {
  const cleanUrl = url.split('?')[0]; 
  const urlSegments = cleanUrl.split('/').filter(Boolean);

  // Filter out UUIDs and numeric IDs
  const meaningfulSegments = urlSegments.filter(
    segment => 
      !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(segment) &&
      !/^\d+$/.test(segment) // Remove pure numbers
  );

  const len = meaningfulSegments.length;

  this.secondLastRoute = len >= 2 
    ? meaningfulSegments[len - 2].replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) 
    : '';
  this.currentPage = len >= 1 
    ? meaningfulSegments[len - 1].replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) 
    : '';
}


  isScrolled = false;

  @HostListener("window:scroll", [])
  onScroll() {
    this.isScrolled = window.scrollY > 10;
  }

   toggleTheme(_: "light" | "night") {
    this.activeLightMode = "light";
  }

  toggleState() {
    this.drawerToggle.emit();
  }

  profileAction(profMenu: {
    name: string;
    path: string;
    icon: string;
    slug: string;
  }) {
    switch (profMenu.slug) {
      case "profile":
        this.userProfile$
          .subscribe((user) => {
            if (user) {
              this.settingsService.openDialogModal({
                component: UserViewComponent,
                data: {
                  user: user,
                },
              });
            }
          })
          .unsubscribe();
        break;
      case "changePassword":
        this.settingsService.openDialogModal({
          component: ResetPasswordComponent,
          data: {},
        });
        break;
        case 'logout':
        this.authService.logout();
        break
    }
  }

  loadUserProfile() {
    this.store.dispatch(UserProfileActions.loadUserProfiles());
    this.userProfile$ = this.store.select(userProfileFeature.selectUser);
  }
  profilePhotoRoute(url) {
    return environment.MEDIA_SERVER_URL + url;
  }
}
